<template>
    <li class="page-suggestion items-center mb-4">
        <div class="ava">
            <vs-avatar size="32px" v-if="item.avatar" :src="item.avatar" class="ml-0" text="Luisd"/>
            <!-- <vs-avatar size="32px" v-if="item.avatar" :src="base_url + item.avatar" class="ml-0" text="Luisd"/>-->
            <div class="con-vs-avatar ml-0" v-else >
                <img  class="mr-3" style="border-radius:25px;" width="32" height="32"  src="@/assets/images/not-photo.png">
            </div>
            <!-- <vs-avatar size="32px" v-else class="ml-0" :text="avatarText"/> -->
        </div>
        <div class="leading-tight user_desc">
            <span class="text-xs font-medium">{{title}}</span>
            <p @click="goToProfile({id: item.profileId ? item.profileId : item.uid})" class="font-medium cursor-pointer"> {{userName}}</p>
            <span class="text-xs">{{ item.email }}</span>
        </div>

        <div class="ml-auto" v-if="is_supervisor">
            <vs-chip :color="primary">{{$t('my_adviser')}}</vs-chip>
        </div>
        <div class="ml-auto">
            <div class="flex justify-around flex-wrap" v-if="is_supervisor">
                <vx-tooltip color="primary" :text="$t('write_a_message')">
                    <vs-button
                        radius
                        v-if="user.profileId !== item.profileId"
                        color="#7367F0"
                        @click="userMessage()"
                        icon-pack="feather"
                        icon="icon-message-square"
                        size="small"
                        class="mt-4 btn"
                        type="flat">
                    </vs-button>
                </vx-tooltip>
<!--                <vx-tooltip color="primary" :text="$t('change_adviser')">-->
<!--                    <vs-button-->
<!--                        :disabled="item.is_mod_can_edit"-->
<!--                        radius-->
<!--                        v-if="user.profileId !== item.profileId"-->
<!--                        color="#7367F0"-->
<!--                        @click="openChangeVisor('openChangeVisor')"-->
<!--                        icon-pack="feather"-->
<!--                        size="small"-->
<!--                        class="mt-4 px-2 mx-2"-->
<!--                        type="flat">-->
<!--                        <feather-icon  color="primary" icon="RotateCwIcon" svgClasses="h-4 w-4"/>-->
<!--                    </vs-button>-->
<!--                </vx-tooltip>-->


                <vx-tooltip color="primary" :text="$t('history_adviser')">
                    <vs-button
                        radius
                        v-if="user.profileId !== item.profileId"
                        color="#7367F0"
                        @click="openChangeVisor('openStoryVisor')"
                        icon-pack="feather"
                        size="small"
                        class="mt-4 px-2 mx-2 btn"
                        type="flat">
                        <feather-icon  color="primary" icon="AlertOctagonIcon" svgClasses="h-4 w-4"/>
                    </vs-button>
                </vx-tooltip>
            </div>
            <div class="flex" v-else>

                <vs-button
                    color="primary"
                      @click="userMessage()"
                    icon-pack="feather"
                    icon="icon-message-square"
                    size="small"
                    class="mt-2 btn"
                    type="filled">
                        {{$t('write_a_message')}}
                </vs-button>
            </div>
        </div>
    </li>
</template>

<script>
import {mapState} from 'vuex'
import vueConfig from "../../../../vue.config";
import CommonMixin from "./CommonMixin";
export default {
    mixins:[CommonMixin],
    props: {
        title: {
            type: String,
            default: ''
        },
        titleColor: {
            type: String,
            default: ''
        },
        item: Object,
        isVisors:{
            type: String,
            default: 'false'
        }
    },
    methods: {
        userMessage() {
            this.$router.push({name: 'chat', query: {user: this.item.profileId}})
        },
        openChangeVisor(fn_name){
            this.$emit(fn_name,true);
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        base_url() { return vueConfig.devServer.proxy["^/api"].target} ,
        userName() {
            // Возвращаем имя человека целиком
            if (this.item.full_name){
                return this.item.full_name
            }
            return `${ this.item.lastName } ${ this.item.firstName } ${ this.item.middleName }`
        },
        is_supervisor(){
            return this.item.role?
                                    this.item.role.is_supervisor?true:false
                                :false;
        },
        avatarText() {
            // Если нет аватара подставляем инициалы
            let title,
                text = this.userName
            const textAr = text.split(' ')
            if (textAr.length) {
                const newTitle = []
                textAr.forEach(item => {
                    newTitle.push(item.substr(0, 1).toUpperCase())
                })
                title = newTitle.join('')
            } else title = text.substr(0, 1)
            return title
        }
    }
}
</script>

<style lang="scss">
.page-suggestion {
        display: flex;
        .ava {
            margin-right: 10px;
        }
    }
@media (max-width: 415px) {
    .page-suggestion {
        display: grid;
        .ava {
            margin: 0 auto;
        }
        .user_desc {
            text-align: center;
        }
        .ml-auto {
            width: 100%;
        }
        .btn {
            width: 100%;
        }
    }
}
</style>
